// extracted by mini-css-extract-plugin
export default {"userMenu":"UD7OIFgwF1LOfPJP234A","login":"jWfqKg10xvcVZqMUgbLQ"};